<template>
  <div>
    <b-popover
      v-for="(data,index) in debtors"
      :key="index"
      ref="popover"
      :target="'popover-reactive-representative-'+data.id"
      triggers="hover"
      placement="auto"
      container="my-container"
    >
      <template #title>
        <div class="d-flex justify-content-between align-items-center">
          <span>Representative Details</span>
        </div>
      </template>
      <table
        class="client-details-table"
      >
        <tr
          class="business-item"
        >
          <td class="left-item-padding">
            {{ $t('DEBTIA_NAME') }}</td>
          <td class="right-values item-padding">
            {{ data.representative ? data.representative.name : 'N/A' }}
          </td>
        </tr>
        <tr class="business-item">
          <td class="left-item-padding">
            {{ $t('DEBTIA_EMAIL') }}
          </td>
          <td class="right-values item-padding">
            <a
              v-if="data.representative && data.representative.email"
              :href="'mailto:' + data.representative.email"
            >
              {{ data.representative.email }}
            </a>
            <span v-else>N/A</span>
          </td>
        </tr>
        <tr
          class="business-item"
        >
          <td class="left-item-padding">
            {{ $t('DEBTIA_PHONE') }}</td>
          <td class="right-values item-padding">
            {{ data.representative ? data.representative.phone : 'N/A' }}
          </td>
        </tr>
        <tr
          class="business-item"
        >
          <td class="left-item-padding">
            {{ $t('DEBTIA_CONTACT_PERSON') }}</td>
          <td class="right-values item-padding">
            {{ data.representative ? data.representative.company : 'N/A' }}
          </td>
        </tr>
      </table>
      <table
        v-if="data.representative && data.representative.address"
        class="client-addressdetails-table table-border"
      >
        <tr
          class="business-item"
        >
          <td class="left-item-padding">
            <h5>{{ $t('DEBTIA_ADDRESS') }}</h5></td>
        </tr>
        <tr
          class="business-item"
        >
          <td class="left-item-padding">
            {{ $t('DEBTIA_HOUSE_NUMBER') }}</td>
          <td class="right-values item-padding">
            {{ data.representative ? data.representative.address.house_no : 'N/A' }}
          </td>
        </tr>
        <tr
          class="business-item"
        >
          <td class="left-item-padding">
            {{ $t('DEBTIA_ROAD_NAME') }}</td>
          <td class="right-values item-padding">
            {{ data.representative ? data.representative.address.road_name : 'N/A' }}
          </td>
        </tr>
        <tr
          class="business-item"
        >
          <td class="left-item-padding">
            {{ $t('DEBTIA_PLACE_NAME') }}</td>
          <td class="right-values item-padding">
            {{ data.representative ? data.representative.address.place : 'N/A' }}
          </td>
        </tr>
        <tr
          class="business-item"
        >
          <td class="left-item-padding">
            {{ $t('DEBTIA_ZIP_CODE') }}</td>
          <td class="right-values item-padding">
            {{ data.representative ? data.representative.address.zip_code : 'N/A' }}
          </td>
        </tr>
        <tr
          class="business-item"
        >
          <td class="left-item-padding">
            {{ $t('DEBTIA_CITY') }}</td>
          <td class="right-values item-padding">
            {{ data.representative ? data.representative.address.city : 'N/A' }}
          </td>
        </tr>
        <tr
          class="business-item"
        >
          <td class="left-item-padding">
            {{ $t('DEBTIA_COUNTRY') }}</td>
          <td class="right-values item-padding">
            {{ data.representative ? data.representative.address.country : 'N/A' }}
          </td>
        </tr>
      </table>
      <b-button
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        variant="outline-primary"
        :to="{ name: 'debtor-view', params: { id: data.id } }"
        target="_blank"
        class="edit-client-btn"
      >
        {{ $t("DEBTIA_VIEW_MORE") }}
        <feather-icon
          icon="ExternalLinkIcon"
        />
      </b-button>
    </b-popover>
  </div>
</template>

<script>
import Ripple from 'vue-ripple-directive'
// import store from '@/store'

import {
  BPopover, BButton,
} from 'bootstrap-vue'

export default {
  components: {
    BPopover,
    BButton,
  },
  directives: {
    Ripple,
  },
  props: {
    debtors: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
    }
  },
  created() {
  },
  methods: {
  },
}
</script>

<style lang="scss">
</style>
